import React from "react";
import {
  MapPin,
  Calendar,
  Users,
  ArrowRight,
  CheckCircle2,
  Clock,
} from "lucide-react";
import { motion } from "framer-motion";

const Inscripciones = () => {
  // Colores base sugeridos y adicionales
  const colors = {
    primary: "#459e5a", // Verde
    bg: "#fef9f5", // Crema
    accent: "#1a365d", // Azul Marino
    detail: "#d97706", // Dorado/Ámbar
  };

  const eventInfo = [
    {
      id: 1,
      title: "Modalidad",
      value: "Presencial",
      icon: <Users className="w-6 h-6" />,
      description: "Interacción directa y networking",
    },
    {
      id: 2,
      title: "Ubicación",
      value: "Centro de convenciones UTPL",
      icon: <MapPin className="w-6 h-6" />,
      description: "Loja, Ecuador",
    },
    {
      id: 3,
      title: "Fecha",
      value: "14, 15 y 16 de octubre de 2026",
      icon: <Calendar className="w-6 h-6" />,
      description: "3 días de aprendizaje intensivo",
    },
  ];

  // Variantes para animaciones escalonadas (stagger)
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  return (
    <div
      className="relative-block flex items-center justify-center p-6 pb-12 pt-12"
      style={{ backgroundColor: colors.bg }}
    >
      <div className="max-w-7xl w-full">
        {/* Info Cards Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
          className="grid md:grid-cols-3 gap-6 "
        >
          {eventInfo.map((item) => (
            <motion.div
              key={item.id}
              variants={itemVariants}
              whileHover={{ y: -5, transition: { duration: 0.2 } }}
              className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 transition-shadow duration-300 hover:shadow-xl"
            >
              <div
                className="w-12 h-12 m-auto rounded-xl flex items-center justify-center mb-4"
                style={{
                  backgroundColor: `${colors.primary}15`,
                  color: colors.primary,
                }}
              >
                {item.icon}
              </div>
              <h3
                className="text-sm font-bold uppercase tracking-wider mb-1 text-center"
                style={{ color: colors.primary }}
              >
                {item.title}
              </h3>
              <p
                className="text-lg font-bold mb-2 text-center"
                style={{ color: colors.accent }}
              >
                {item.value}
              </p>
              <p className="text-sm text-gray-500 leading-relaxed text-center">
                {item.description}
              </p>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </div>
  );
};

export default Inscripciones;
